export default [
  //    - Booking details
  {
    path: '/bookings',
    name: 'foravila-bookings',
    component: () => import('@/views/foravila/bookings/list/BookingsList.vue'),
  },
]
